import { waMessages } from "@/lib/whatsapp";
import WhatsAppLink from "@/components/feature/WhatsAppLink";
import Reveal from "@/components/feature/Reveal";

export default function FinalCta() {
  return (
    <section className="bg-primary-900">
      <div className="mx-auto max-w-5xl px-4 py-20 text-center md:px-6 md:py-28">
        <Reveal>
          <div className="mx-auto mb-6 h-px w-16 bg-accent-500" aria-hidden="true"></div>
          <h2 className="font-heading text-3xl leading-tight text-background-50 md:text-6xl">
            Bir sonraki dokunuşu birlikte planlayalım.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-background-200/80 md:text-lg">
            Saç tasarımı, gelin hazırlığı ya da güzellik bakımı; size en uygun zamanı birlikte
            belirlemek için WhatsApp'tan yazın.
          </p>
          <WhatsAppLink
            message={waMessages.general}
            label="WhatsApp'tan Yazın"
            variant="whatsapp"
            size="lg"
            sourceSection="final_cta"
            className="mt-9"
          />
        </Reveal>
      </div>
    </section>
  );
}